export function InputText({
  value,
  placeholder,
}: {
  value: string;
  placeholder: string;
}) {
  return (
    <div
      className={`w-full bg-white border border-gray-200 rounded-md flex items-center justify-center h-12 pt-1 ${
        value === "" ? "text-gray-400" : ""
      }`}
    >
      {value === "" ? placeholder : value}
    </div>
  );
}
